/**
 * @desc 更新msku状态
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.omsFlow.mskuMap.updateStatus.Params, options?: any) {
  return updateResponse(
    http(URL + `/mskuMap/updateStatus`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
